/* eslint-disable react/jsx-max-props-per-line */
/* eslint-disable react/jsx-sort-props */
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { TableCell } from '@mui/material';
import moment from 'moment';
import * as actionsVeiculos from '../../../store/veiculo/actions';
import * as selectorsAuth from '../../../store/auth/reducer';
import * as selectorsVeiculos from '../../../store/veiculo/reducer';
import * as Role from '../../../constants/role';
import { getMaxColumnLength } from '../../../utils';
import { TableWidgetV2 } from '../../../components/v2';
import HistoricoVeiculoModal from './HistoricoVeiculoModal';
import { ordernarPorDataHistorico, tipoHistoricoNome } from './helpers';

const HistoricoTab = ({ idVeiculo, historico, userRole, deleteHistoricoVeiculo }) => {
  const [open, setOpen] = useState(false);
  const [rows, setRows] = useState([]);
  const [historicoVeiculoId, setHistoricoVeiculoId] = useState(null);

  const isAdmin = () => Role.ADMIN === userRole || Role.SUPER_ADMIN === userRole;

  const renderRows = (h) => (
    <>
      <TableCell>{moment(h.dataHistorico).format('DD/MM/YYYY')}</TableCell>
      <TableCell>{tipoHistoricoNome(h.tipoHistorico)}</TableCell>
      <TableCell size="medium" title={h.observacao}>
        {getMaxColumnLength(h.observacao)}
      </TableCell>
    </>
  );

  const onDelete = (rowId) => {
    deleteHistoricoVeiculo(rowId, () => {
      setRows([...rows.filter((s) => s.id !== rowId)]);
    });
  };

  const onEdit = (rowId) => {
    setHistoricoVeiculoId(rowId);
    setOpen(true);
  };

  const onAdd = () => {
    setHistoricoVeiculoId(null);
    setOpen(true);
  };

  const afterSave = (data) => {
    setRows([...rows.filter((s) => s.id !== data.id), data].sort(ordernarPorDataHistorico));
  };

  useEffect(() => {
    setRows(historico || []);
  }, [historico]);

  return (
    <>
      <TableWidgetV2
        rows={rows}
        titles={['Data', 'Tipo', 'Descrição']}
        deleteMessage="A informação será removido e não poderá ser mais recuperado."
        renderRows={renderRows}
        onEdit={onEdit}
        showDeleteRow={(row) => !row.readOnly}
        onDelete={onDelete}
        onAdd={onAdd}
        hasRowActions={isAdmin()}
        hasAdd={isAdmin()}
      />
      <HistoricoVeiculoModal
        open={open}
        onClose={() => {
          setHistoricoVeiculoId(null);
          setOpen(false);
        }}
        idVeiculo={idVeiculo}
        id={historicoVeiculoId}
        afterSave={afterSave}
      />
    </>
  );
};

HistoricoTab.propTypes = {
  idVeiculo: PropTypes.string,
  historico: PropTypes.array,
  userRole: PropTypes.string,
  deleteHistoricoVeiculo: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  userRole: selectorsAuth.getRole(state),
});

const mapDispatchToProps = (dispatch) => bindActionCreators({
  ...actionsVeiculos,
  ...selectorsVeiculos,
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(HistoricoTab);
